import {combineReducers} from 'redux';
import {issues, issuesMap, pushIssues, trackersMap} from './events';
import {notifications, notiCount} from './notifications';
import {users, getUser, usersMap, techLocation} from './users';
import {account, token} from './auth';
import {projects, curProjectID} from './projects';
import {overview, overviewByUser, overviewByTrackers} from './overview';
import {errors} from './errors';
import {routerReducer} from 'react-router-redux';
import {reducer as formReducer} from 'redux-form';

export default combineReducers({
    issues,
    issuesMap,
    pushIssues,
    trackersMap,
    users,
    usersMap,
    techLocation,
    projects,
    curProjectID,
    overview,
    overviewByUser,
    overviewByTrackers,
    notifications,
    notiCount,
    getUser,
    account,
    token,
    form: formReducer,
    routing: routerReducer,
    errors: errors,
});


// WEBPACK FOOTER //
// ./src/reducers/index.js